import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const errorMessageCss = {
  fontWeight: 500,
  marginTop: '-10px',
  color: '#E7000A',
  fontSize: 12,
  '& >a': {
    textDecoration: 'underline',
    color: '#E7000A',
  },
};
const useStyles = createUseStyles<string, { hasError: boolean }, ITheme>(
  ({ breakpoints, colors }: ITheme) => ({
    buttonToggle: {
      margin: 'auto',
      marginTop: 20,
      width: 400,
      backgroundColor: '#FFFFFF',
      [mediaQuery(breakpoints.tablet)]: {
        marginTop: 16,
        width: 346,
      },
    },
    navbar: {
      background: '#ffffff',
    },
    svgClassName: {
      zIndex: 100,
      '& > svg': {
        '&:hover': {
          fill: 'white',
        },
      },
    },
    optionsContainer: {
      display: 'flex',
      gap: 16,
      justifyContent: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        alignContent: 'center',
      },
    },
    textField: {
      width: '178px',
      maxHeight: '48px',
      background: '#FFFFFF',
      borderColor: ({ hasError }) => (hasError ? '#E7000A' : colors.borderColor),
      '&:focus, &:active': {
        borderColor: ({ hasError }) => (hasError ? '#E7000A' : colors.borderColor),
      },
      [mediaQuery(breakpoints.tablet)]: {
        width: '295px',
      },
    },
    errorMessage: {
      ...errorMessageCss,
      display: 'block',
      [mediaQuery(breakpoints.tablet)]: {
        display: 'none',
      },
    },
    smallDeviceErrorMessage: {
      maxWidth: '295px',
      ...errorMessageCss,
      display: 'none',
      [mediaQuery(breakpoints.tablet)]: {
        display: 'block',
      },
    },
    generateButtonClass: {
      width: '178px',
      maxHeight: '48px',
      [mediaQuery(breakpoints.tablet)]: {
        width: '295px',
        height: '48px',
      },
    },

    randomButtonWrap: {
      flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 10,
    },

    randomButtonClass: {
      '&:hover svg path': {
        fill: '#fff',
      },
      width: '198px',
      maxHeight: '48px',
      [mediaQuery(breakpoints.tablet)]: {
        width: '295px',
        height: '48px',
      },
    },
    heroBanner: {
      '& img': {
        width: 154,
        height: 134,
      },
      '& > article': {
        paddingTop: 52,
        paddingBottom: 56,
      },
      [mediaQuery(breakpoints.tablet)]: {
        '& img': {
          width: 112,
          height: 98,
        },
        '& > article': {
          paddingTop: 16,
          paddingBottom: 16,
        },
      },
    },
    boldText: {
      fontWeight: 'bold',
      color: '#C209C1',
    },
  }),
  {
    name: 'home',
  },
);

export default useStyles;
